import React from 'react'
import { useSelector } from 'react-redux'

import history from 'browserHistory'
import { HistoryButtonsLocation } from './reducer'
import { getNote } from 'data/notes/selectors'
import { getChannel } from 'data/channels/selectors'
import { getChannelLabel } from 'data/channels/helpers'

export function useHistoryStateSession() {}

export function useDocTitleOrDefault(
  location: HistoryButtonsLocation | null,
  defaulText: string
): string {
  return useSelector(state => {
    if (!location) {
      return defaulText
    }

    if (location.noteId) {
      const note = getNote(state, location.noteId)
      if (note && note.title) {
        return note.title
      }
    }

    if (location.templateId) {
      const note = getNote(state, location.templateId)
      if (note && note.title) {
        return note.title
      }
    }

    if (location.channelId) {
      const channel = getChannel(state, location.channelId)
      if (channel) {
        return getChannelLabel(channel)
      }
    }

    return defaulText
  })
}

export function useHistoryButtonClickCallback(
  location: HistoryButtonsLocation | null,
  searchString: string
): () => void {
  return React.useCallback(
    () => {
      if (!location) {
        return null
      }
      history.push({
        pathname: location.pathname,
        search: searchString,
      })
    },
    [location, searchString]
  )
}
